import { toast } from "@loot-os/ui/components/sonner";
import { MutationCache, QueryClient } from "@tanstack/react-query";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      /** True when the page shows this failure itself, so the query client shows no toast for it. */
      showsError?: (error: Error) => boolean;
    };
  }
}

/**
 * Module-scope query client so non-React modules (lib/tenantScope.ts) can clear
 * the cache when the route's tenant scope changes.
 *
 * Every failed mutation is announced here, as a toast, so no router renders
 * `mutation.error` itself: the message reaches the user without a banner
 * appearing in the page and pushing the form down. A mutation whose
 * `meta.showsError` returns true for a failure is the one exception.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.showsError?.(error)) return;
      toast.error(error.message);
    },
  }),
});
